"use strict";
/**
 * Copyright © 2021 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.columnMapperColumns = void 0;
const react_1 = __importDefault(require("react"));
const column_components_1 = require("./view-utils/column-components");
const ImportedColumnName_1 = require("./view-utils/ImportedColumnName");
exports.columnMapperColumns = [
    {
        headerName: ' ',
        field: 'id',
        flex: 0.25,
        sortable: false,
        renderCell: (params) => react_1.default.createElement(column_components_1.ColumnNumber, Object.assign({}, params)),
    },
    {
        headerName: 'Readable name',
        field: 'readableName',
        flex: 1,
        sortable: false,
        renderCell: (params) => react_1.default.createElement(column_components_1.ColumnName, { variant: "default", value: params.row.readableName }),
    },
    {
        headerName: 'Column name',
        field: 'columnName',
        flex: 1,
        sortable: false,
        editable: true,
        renderCell: (params) => react_1.default.createElement(column_components_1.ColumnName, { variant: "none", value: params.row.columnName }),
        renderEditCell: (params) => react_1.default.createElement(ImportedColumnName_1.ImportedColumnName, Object.assign({}, params)),
    },
    {
        headerName: 'Example',
        field: 'example',
        flex: 1,
        sortable: false,
        renderCell: (params) => react_1.default.createElement(react_1.default.Fragment, null, params.row.example),
    },
];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29sdW1ucy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL2RhdGEtdXBsb2FkL2NvbHVtbnMudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQTs7Ozs7O0dBTUc7Ozs7OztBQUVILGtEQUEwQjtBQUcxQixzRUFBMEU7QUFDMUUsd0VBQXFFO0FBRXhELFFBQUEsbUJBQW1CLEdBQWlCO0lBQy9DO1FBQ0UsVUFBVSxFQUFFLEdBQUc7UUFDZixLQUFLLEVBQUUsSUFBSTtRQUNYLElBQUksRUFBRSxJQUFJO1FBQ1YsUUFBUSxFQUFFLEtBQUs7UUFDZixVQUFVLEVBQUUsQ0FBQyxNQUFzQixFQUFFLEVBQUUsQ0FBQyw4QkFBQyxnQ0FBWSxvQkFBSyxNQUFNLEVBQUk7S0FDckU7SUFDRDtRQUNFLFVBQVUsRUFBRSxlQUFlO1FBQzNCLEtBQUssRUFBRSxjQUFjO1FBQ3JCLElBQUksRUFBRSxDQUFDO1FBQ1AsUUFBUSxFQUFFLEtBQUs7UUFDZixVQUFVLEVBQUUsQ0FBQyxNQUFzQixFQUFFLEVBQUUsQ0FBQyw4QkFBQyw4QkFBVSxJQUFDLE9BQU8sRUFBQyxTQUFTLEVBQUMsS0FBSyxFQUFFLE1BQU0sQ0FBQyxHQUFHLENBQUMsWUFBWSxHQUFJO0tBQ3pHO0lBQ0Q7UUFDRSxVQUFVLEVBQUUsYUFBYTtRQUN6QixLQUFLLEVBQUUsWUFBWTtRQUNuQixJQUFJLEVBQUUsQ0FBQztRQUNQLFFBQVEsRUFBRSxLQUFLO1FBQ2YsUUFBUSxFQUFFLElBQUk7UUFDZCxVQUFVLEVBQUUsQ0FBQyxNQUFzQixFQUFFLEVBQUUsQ0FBQyw4QkFBQyw4QkFBVSxJQUFDLE9BQU8sRUFBQyxNQUFNLEVBQUMsS0FBSyxFQUFFLE1BQU0sQ0FBQyxHQUFHLENBQUMsVUFBVSxHQUFJO1FBQ25HLGNBQWMsRUFBRSxDQUFDLE1BQWdDLEVBQUUsRUFBRSxDQUFDLDhCQUFDLHVDQUFrQixvQkFBSyxNQUFNLEVBQUk7S0FDekY7SUFDRDtRQUNFLFVBQVUsRUFBRSxTQUFTO1FBQ3JCLEtBQUssRUFBRSxTQUFTO1FBQ2hCLElBQUksRUFBRSxDQUFDO1FBQ1AsUUFBUSxFQUFFLEtBQUs7UUFDZixVQUFVLEVBQUUsQ0FBQyxNQUFzQixFQUFFLEVBQUUsQ0FBQyw4REFBRyxNQUFNLENBQUMsR0FBRyxDQUFDLE9BQU8sQ0FBSTtLQUNsRTtDQUNGLENBQUMifQ==